module.exports = __webpack_public_path__ + "static/media/relation.df754a9f.png";